<div class="full-view">

  <ng-container #container></ng-container>

  @if (showDialog && npsDetailData) {
    <app-nps-dialog
      [placementInCenter]="!!npsDetailData.dialogPlacementInCenter"
      [phrases]="currentPhrases"
      [name]="npsDetailData.name"
      [cssClass]="npsDetailData.cssClass"
      [odwrotnie]="npsDetailData.odwrotnie"
      [smooth]="npsDetailData.smooth"
      (closeDialog)="closeDialog($event)"
    />
  }
</div>